export const PROJECT_ADMIN = 'Project Admin' as const;
export const CUSTOMER = 'Customer' as const;
export const AGENT = 'Agent' as const;

export type SUPPORTED_WHO_CHOOSES_APPROVERS = typeof PROJECT_ADMIN | typeof CUSTOMER | typeof AGENT;
